import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

import { AppRoutes } from 'config/routes';

import { canOpenPayroll } from './permissions';

interface AuthFeaturesState {
  auth?: { user?: { features?: string[] } };
}

// The signed-in role's features, read straight from the auth slice: the
// guard sits in the route table, so it stays free of the store's API modules.
const selectFeatures = (state: AuthFeaturesState) => state.auth?.user?.features;

/**
 * PAYROLL DASHBOARD route guard (plan §5): only a role holding the `payroll`
 * tick opens /payroll (owner 2 Nov 2026; it was Company Owner,
 * Administrative and Accounting). Anyone else gets today's no-access answer
 * (back to Home, as Booking does). Ops answers 403 as well.
 */
export const PayrollRouteGuard = ({ children }: PropsWithChildren) => {
  const features = useSelector(selectFeatures);
  if (!canOpenPayroll(features)) {
    return <Navigate replace to={AppRoutes.Home} />;
  }
  return children || <Outlet />;
};
